export default "__VITE_ASSET__00a7d39c__"